import grey from "@material-ui/core/colors/grey"
import Checkbox from "@material-ui/core/Checkbox"
import withStyles from "@material-ui/core/styles/withStyles"
import React from "react"

const GrayCheckbox = withStyles({
  root: {
    color: grey[700],
    "&$checked": {
      color: grey[100],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />)

export default GrayCheckbox
